import React, { useContext, useEffect, useRef, useState } from "react"
import { Autocomplete, Box, FormControl, IconButton, InputAdornment, MenuItem, Paper, Popover, Select, TextField } from "@mui/material";
import CommonTypo from "../../../components/CommonTypo";
import { pxToRem } from "../../../theme/typography";
import palette from "../../../theme/palette";
import { InsightTypeContext } from "../../../context/userInsights";

import MoreButton from "../MoreButton";
import { influenceService } from "../../../services/influence";
import { UserTypeContext } from "../../../context/userStatus";
import { InfluenceGetResponse } from "../../../interfaces/insightsModal";
import { addInfluenceAction } from "../../../store/actions/userTypeAction";
import { insightsService } from "../../../services/insightsService";
import moment from "moment";
import AreasTable from "./AreasTable";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ArrowUp from "../../../assets/images/icon/arrow_up";
import { DatePicker, LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ArrowUpNew } from "../../../assets/images/icon/ArrowDownGreenNew";
import NewButton from "../../../components/NewButton";
import insightsProgressStyles from "../insightsClasses";
dayjs.extend(customParseFormat);


const CheckCircle = () => <span className="hide-element"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9974 6.00244L10.9975 6.00258C11.0631 6.0679 11.1151 6.14552 11.1506 6.23099C11.1861 6.31645 11.2043 6.40808 11.2043 6.50063C11.2043 6.59317 11.1861 6.6848 11.1506 6.77026C11.1151 6.85573 11.0631 6.93335 10.9975 6.99867L10.9975 6.99873L7.49748 10.4987L7.49742 10.4988C7.4321 10.5643 7.35448 10.6163 7.26902 10.6518C7.18355 10.6873 7.09192 10.7056 6.99938 10.7056C6.90684 10.7056 6.81521 10.6873 6.72974 10.6518C6.64427 10.6163 6.56665 10.5643 6.50133 10.4988L6.50127 10.4987L5.00127 8.99873C4.93586 8.93332 4.88397 8.85566 4.84857 8.7702C4.81317 8.68473 4.79495 8.59313 4.79495 8.50062C4.79495 8.40812 4.81317 8.31652 4.84857 8.23105C4.88397 8.14559 4.93586 8.06793 5.00127 8.00252C5.06669 7.93711 5.14434 7.88522 5.22981 7.84982C5.31527 7.81442 5.40687 7.7962 5.49938 7.7962C5.59188 7.7962 5.68348 7.81442 5.76895 7.84982C5.85441 7.88522 5.93207 7.93711 5.99748 8.00252L5.9975 8.00254L6.96688 8.97067L7.00003 9.00377L7.03315 8.97064L10.0025 6.00069C10.0679 5.93543 10.1455 5.8837 10.231 5.84847C10.3164 5.81323 10.4079 5.79518 10.5003 5.79535C10.5927 5.79551 10.6842 5.81388 10.7695 5.84942C10.8548 5.88496 10.9322 5.93695 10.9974 6.00244ZM13.2969 8.00005V8C13.2969 6.95238 12.9862 5.92828 12.4042 5.05721C11.8222 4.18615 10.9949 3.50723 10.027 3.10633C9.05915 2.70542 7.99413 2.60052 6.96663 2.8049C5.93914 3.00928 4.99533 3.51376 4.25455 4.25454C3.51377 4.99532 3.00929 5.93914 2.80491 6.96663C2.60052 7.99412 2.70542 9.05915 3.10633 10.027C3.50724 10.9949 4.18615 11.8222 5.05722 12.4042C5.92828 12.9862 6.95238 13.2969 8 13.2969H8.00005C9.4044 13.2954 10.7508 12.7368 11.7438 11.7438C12.7368 10.7508 13.2954 9.40439 13.2969 8.00005ZM14.7031 8.00005C14.7031 9.32579 14.31 10.6217 13.5734 11.7241C12.8369 12.8264 11.79 13.6855 10.5652 14.1929C9.34034 14.7002 7.99257 14.833 6.69229 14.5743C5.39201 14.3157 4.19763 13.6773 3.26018 12.7398C2.32273 11.8024 1.68432 10.608 1.42568 9.30771C1.16704 8.00744 1.29978 6.65966 1.80712 5.43482C2.31447 4.20999 3.17362 3.1631 4.27595 2.42656C5.37826 1.69001 6.67423 1.29688 7.99998 1.29688C9.77715 1.29885 11.481 2.00571 12.7376 3.26237C13.9943 4.51903 14.7012 6.22286 14.7031 8.00005Z" fill="#3E4240" stroke="#3E4240" stroke-width="0.09375" />
</svg>
</span>

const ArrowDown = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1090_701)">
        <path d="M13.825 6.6665L10 10.4832L6.175 6.6665L5 7.8415L10 12.8415L15 7.8415L13.825 6.6665Z" fill="#656565" />
    </g>
    <defs>
        <clipPath id="clip0_1090_701">
            <rect width="20" height="20" fill="white" />
        </clipPath>
    </defs>
</svg>
const ArrowIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1090_701)">
        <path d="M13.825 6.6665L10 10.4832L6.175 6.6665L5 7.8415L10 12.8415L15 7.8415L13.825 6.6665Z" fill="#656565" />
    </g>
    <defs>
        <clipPath id="clip0_1090_701">
            <rect width="20" height="20" fill="white" />
        </clipPath>
    </defs>
</svg>

const InfluenceAreas = () => {
    const selectRef = useRef(null);
    const { state: InsightState, dispatch: insightTypeDispatch } =
        useContext(InsightTypeContext);
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const [MenuOpen, setMenuOpen] = useState(false)
    const [allFilters, setAllFilters] = useState([])
    const [areaData, setAreaData] = useState([])
    const [selectedRange, setSelectedRange] = useState("CURRENT_MONTH")
    const [loadingResponse, setLoadingResponse] = useState(false);
    const [selectedInfluenceId, setSelectedInfluenceId] = useState<any>({
        categoryId: "ALL_AREAS",
        name: "All areas",
    });
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [startshowPicker, setstartShowPicker] = useState(false)
    const [endshowPicker, setendShowPicker] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const [influenceResponse, setInfluenceResponse] = useState<any>({});
    useEffect(() => {
        if (selectedRange !== "CUSTOM") {
            getInfluenceList()
        }
    }, [selectedRange, selectedInfluenceId])
    useEffect(() => {
        if (startDate && endDate) {
            getInfluenceList(startDate, endDate)
        }
    }, [startDate, endDate, selectedInfluenceId])
    // useEffect(() => {
    //     console.log("selectedInfluenceId", selectedInfluenceId);

    //     if (selectedInfluenceId && selectedInfluenceId.influenceId) getInfluenceResposne()
    // }, [selectedInfluenceId])

    // const getInfluenceResposne = () => {
    //     console.log("selectedInfluenceId", selectedInfluenceId);
    //     setLoadingResponse(true)
    //     const userId: any = {
    //         "influenceId": selectedInfluenceId.influenceId,
    //         // "dateType": selectedRange,
    //         "from": moment().subtract(5, 'year').startOf("year").format(),
    //         "to": moment().endOf("year").format(),
    //         influenceType: selectedInfluenceId.type === "TYPE3" && [true, "true"].includes(selectedInfluenceId.inverse)
    //             ? "INFLUENCETYPE3INVERSE"
    //             : selectedInfluenceId.type === "TYPE3"
    //                 ? "INFLUENCETYPE3"
    //                 : selectedInfluenceId.type
    //     };
    //     insightsService
    //         .getInfluenceInsights(userId, IUserTypeState.token)
    //         .then((data: any) => {
    //             setInfluenceResponse(data)
    //             setLoadingResponse(false)
    //         })
    //         .catch((error) => {
    //             console.log("User profile Error", error);
    //             setLoadingResponse(false)
    //         });
    // }

    const getInfluenceList = (startDate = null, endDate = null) => {
        let objToSend = {
            "dateType": selectedRange,
            categoryId: selectedInfluenceId.categoryId
        }
        if (startDate && endDate) {
            objToSend["from"] = typeof startDate === "object" ? dayjs(startDate).format("MM-DD-YYYY") : startDate
            objToSend["to"] = typeof endDate === "object" ? dayjs(endDate).format("MM-DD-YYYY") : endDate
        }
        setLoadingResponse(true)
        influenceService
            .getAreas(objToSend, IUserTypeState.token)
            .then((data) => {
                console.log("data", data);
                setAllFilters(data.allData)
                setAreaData(data.data)
                setLoadingResponse(false)
                // userTypeDispatch(addInfluenceAction(data?.data));
            })
            .catch((error) => {
                console.log("influence Error");
            });
    };
    console.log("allFilters", allFilters);

    const defaultProps = {
        options: allFilters && allFilters.length > 0 ? [{
            categoryId: "ALL_AREAS",
            name: "All areas"
        }, ...allFilters.sort(function (a, b) {
            if (a.name && b.name && a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
            }
            if (a.name && b.name && a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
            }
            return 0;
        })] : [{
            categoryId: "ALL_AREAS",
            name: "All areas"
        }],
        getOptionLabel: (option) => option && option.name,

    };
    let responseCount = 0
    if (influenceResponse && influenceResponse.data) {
        const { data = [] } = influenceResponse
        responseCount = data[0]?.responseCount
    }
    const renderMenuItem = (value, title) => (
        <MenuItem value={value} sx={{
            padding: "12px !important",
            fontSize: `${pxToRem(14)} !important`,
            fontWeight: selectedRange === value ? `600 !important` : `400 !important`,
            color: "#3E4240 !important",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }}>{title}
            {selectedRange === value && <CheckCircle />}</MenuItem>
    )
    return (
        <>
            <Box sx={{ flexGrow: 1, }}>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px"
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px"
                    }}>
                        <CommonTypo size={16} color="#656565" fontWeight={400} extraSx={{
                        }}>{"Choose the area to see it data"}</CommonTypo>
                        <Box sx={{
                            display: "flex",
                            gap: "16px",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <Autocomplete
                                className="fillTextInput weekSelect"
                                fullWidth
                                // value={selectedLeft}
                                sx={{
                                    position: "relative",
                                    "& .MuiOutlinedInput-root": {
                                        padding: 0,
                                    },
                                }}
                                renderGroup={(params) => {
                                    return (
                                        <li key={params.key}>
                                            <Box sx={{ padding: '10px 10px' }}>
                                                <CommonTypo color={palette.primary.light} fontWeight={700} size={16} lineHeight={20} extraSx={{
                                                    cursor: "pointer",
                                                    // textAlign: "center !important",
                                                    fontWeight: `700 !important`,
                                                    "&.MuiTypography-root": {
                                                        "@media  (max-width: 600px) and (min-width: 100px)": {
                                                            fontSize: `${pxToRem(16)} !important`,
                                                            lineHeight: "100% !important",
                                                        },
                                                    },
                                                }}>{params.group}</CommonTypo>
                                            </Box>
                                            <Box sx={{ padding: '0 0px' }}>
                                                {params.children}
                                            </Box>
                                        </li>
                                    )
                                }}
                                groupBy={(option) => option.category}
                                getOptionDisabled={(option) => option.disabled}
                                autoComplete
                                popupIcon={<ArrowIcon />}
                                PaperComponent={({ children }) => (
                                    <Paper
                                        style={{ background: "#FFF" }}
                                        sx={{
                                            "&.MuiAutocomplete-option": {
                                                color: "rgb(0, 0, 0)",
                                                fontSize: "18px",
                                            },
                                            "& .MuiAutocomplete-listbox": {
                                                padding: "0px",
                                                "& li": {
                                                    padding: `10px`,
                                                    color: "#5E5F5E !important",
                                                    fontSize: "16px !important",
                                                    fontWeight: "400 !important",
                                                    lineHeight: "24px",
                                                },
                                            },
                                        }}
                                    >
                                        {children}
                                    </Paper>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={{
                                            border: "1px solid #EEEEEE",
                                            borderRadius: "8px",
                                            "&.MuiOutlinedInput-root": {
                                                padding: 0,

                                            },
                                            "& .MuiOutlinedInput-root": {
                                                background: "#FFF",
                                                border: "none"
                                            }
                                        }}
                                        className="fillTextInput weekSelect"
                                        label="Select one"
                                    />
                                )}
                                onChange={(e, newInputValue) => {
                                    if (newInputValue) {
                                        setSelectedInfluenceId(newInputValue);
                                    } /* else {
                                        setSelectedInfluenceId({
                                            categoryId: "ALL_AREAS",
                                            name: "All areas",
                                        })
                                    } */
                                }}
                                defaultValue={{
                                    influenceId: "all",
                                    name: "All areas",
                                }}
                                value={selectedInfluenceId}
                                {...defaultProps}
                            />
                            <Box sx={{
                                display: "flex",
                                gap: "8px",
                                alignItems: "center"
                            }}>
                                <Box sx={{
                                    display: "flex",
                                    gap: "28px",
                                    alignItems: "center"
                                }}>
                                    <Box sx={{
                                        rotate: "90deg",
                                        cursor: "pointer"
                                    }}><ArrowIcon /></Box>
                                    <Box sx={{
                                        rotate: "270deg",
                                        cursor: "pointer"
                                    }}><ArrowIcon /></Box>
                                </Box>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <Select
                                        labelId="demo-simple-select-filled-label"
                                        id="demo-simple-select-filled"
                                        sx={{
                                            // padding: "16px, 12px, 16px, 16px",
                                            "&.MuiInputBase-root": {
                                                height: "40px",
                                                borderRadius: "20px",
                                                padding: "16px 12px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "8px",
                                                color: "#656565",
                                                fontSize: `${pxToRem(16)} !important`,
                                                "&.Mui-focused": {
                                                    background: "#EEEEEE"
                                                },
                                                "&::before": {
                                                    borderBottom: "0px !important"
                                                },
                                                "&.MuiSelect-root:hover:not(.Mui-disabled):before": {
                                                    borderBottom: "0px",
                                                },
                                                "&::hover": {
                                                    borderBottom: "0px",
                                                    "&::before": {
                                                        borderBottom: "0px"
                                                    },
                                                },
                                                "&::after": {
                                                    borderBottom: "0px"
                                                },
                                                "& .MuiSelect-select": {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "0px",
                                                    "&:focus": {
                                                        backgroundColor: "transparent"
                                                    },
                                                    "& .hide-element": {
                                                        display: "none"
                                                    }
                                                }
                                            }
                                        }}
                                        ref={selectRef}
                                        value={selectedRange}
                                        onChange={(event) => {
                                            if (event.target.value === "CUSTOM") {
                                                setAnchorEl(selectRef.current)
                                            }
                                            setSelectedRange(event.target.value)
                                        }}
                                        IconComponent={MenuOpen ? ArrowIcon : ArrowDown}
                                        MenuProps={{
                                            sx: {
                                                "& .MuiPaper-root": {
                                                    borderRadius: "12px",
                                                    boxShadow: "0px 0px 64px 0px #190D1A1A",
                                                    width: "168px",
                                                }
                                            }
                                        }}
                                        onOpen={() => setMenuOpen(true)}
                                        onClose={() => setMenuOpen(false)}
                                    >
                                        {[{
                                            value: "CURRENT_TWO_WEEKS",
                                            title: "Last 14 days"
                                        },
                                        {
                                            value: "PREVIOUS_MONTH",
                                            title: "Last month"
                                        },
                                        {
                                            value: "CURRENT_MONTH",
                                            title: "This month"
                                        },
                                        {
                                            value: "PREVIOUS_QUARTER",
                                            title: "Last quarter"
                                        },
                                        {
                                            value: "CURRENT_QUARTER",
                                            title: "This quarter"
                                        },
                                        {
                                            value: "PREVIOUS_YEAR",
                                            title: "Last year"
                                        },
                                        {
                                            value: "CURRENT_YEAR",
                                            title: "This year"
                                        },
                                        {
                                            value: "CUSTOM",
                                            title: "Custom"
                                        }].map(it => renderMenuItem(it.value, it.title))}
                                    </Select>
                                </FormControl>
                                <Popover
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    sx={{
                                        '& .MuiPaper-root': {
                                            background: "#FFFFFF",
                                            boxShadow: "0px 0px 64px 0px #190D1A1A",
                                            borderRadius: "12px",
                                            width: "312px"
                                        }
                                    }}
                                >
                                    <Box sx={{
                                        padding: "16px",
                                        borderRadius: "12px",

                                    }}>
                                        <Box sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "16px"
                                        }}>
                                            <Box sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px"
                                            }} onClick={() => {
                                                handleClose()
                                            }}>
                                                <Box sx={{
                                                    rotate: "270deg",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    height: "16px",
                                                    width: "16px"
                                                }}>
                                                    <ArrowUp color="#3E4240" size="16" />
                                                </Box>
                                                <CommonTypo size={16} color="#3E4240" fontWeight={400}>Back</CommonTypo>
                                            </Box>
                                            <DatePick name={"Starts"} selectedDate={startDate} setSelectedDate={setStartDate} showpicker={startshowPicker} setShowPicker={() => {
                                                setstartShowPicker(true)
                                                setendShowPicker(false)
                                            }}
                                            />
                                            <DatePick name={"Ends"} selectedDate={endDate} setSelectedDate={setEndDate} showpicker={endshowPicker} setShowPicker={() => {
                                                setendShowPicker(true)
                                                setstartShowPicker(false)
                                            }}
                                            />
                                            <NewButton extraSx={{
                                                height: "40px"
                                            }} isDisabled={!startDate && !endDate} buttonText="Save" padding="16px" borderRadius="20px !important" fontWeight={600} typographySx={{
                                                fontWeight: 600
                                            }} onClick={() => {
                                                handleClose()
                                                getInfluenceList(startDate, endDate)
                                                // getTrendChart(dayjs(startDate).format("MM-DD-YYYY"), dayjs(endDate).format("MM-DD-YYYY"))
                                            }} />
                                        </Box>
                                    </Box>
                                </Popover>
                            </Box>
                        </Box>

                        <MoreButton showMoreButton={false} active={false} onClick={() => { }} fullHeight={false} />

                    </Box>
                    <AreasTable areaData={areaData} selectedRange={selectedRange} loadingResponse={loadingResponse} />
                    {/* {selectedInfluenceId && selectedInfluenceId.influenceId && !loadingResponse && (
                        <>
                            <DataEntryInfluence
                                setSelectOutcome={() => { }}
                                selectOutcome={selectedInfluenceId}
                                outcomeData={InsightState.insights.data}
                                influenceResponse={influenceResponse}
                            />
                            {responseCount >= 14 && (
                                <>
                                    <InfluenceChart selectOutcome={selectedInfluenceId} outcomeData={InsightState.insights.data} />
                                    <PositiveNegativeInfluences influenceResponse={influenceResponse} />
                                    <GoalsInfluences influenceResponse={influenceResponse} selectOutcome={selectedInfluenceId} />
                                </>
                            )}

                        </>
                    )} */}

                </Box>

            </Box>
        </>
    )
}

export default InfluenceAreas

const DatePick = ({
    name, selectedDate, setSelectedDate, showpicker, setShowPicker
}) => {
    const classes = insightsProgressStyles()
    const [popupvisible, setpopupvisible] = useState(false)

    return <Box display={"flex"} flexDirection={"column"} gap={"8px"} alignItems={"flex-start"} >
        <CommonTypo size={12} color="#656565" fontWeight={400}>{name}</CommonTypo>
        <LocalizationProvider dateAdapter={AdapterDayjs} >
            <TextField
                value={selectedDate ? selectedDate.format("DD MMM YYYY") : ""}
                onClick={(event) => {
                    event.currentTarget.blur()
                    setShowPicker(true)
                }}
                onFocus={(event) => event.currentTarget.blur()}
                sx={{
                    width: "100%",
                    "&.MuiTextField-root": {
                        marginBottom: "0px !important",
                    },
                    "& .MuiOutlinedInput-root": {
                        alignItems: "center",
                        color: "#19442E",
                        gap: "8px",
                        borderRadius: "16px !important",
                        border: "1px solid #F3F3F3",
                        background: "#FFF",
                        "& .MuiOutlinedInput-input": {
                            padding: "16px 12px !important",
                            color: "#19442E!important",
                            '&::placeholder': {
                                textTransform: "uppercase"
                            },
                        },
                    },
                }}
            />
            {showpicker && (
                <StaticDatePicker
                    value={selectedDate}
                    onChange={(newValue) => {
                        console.log("Selected date:", newValue);
                        setSelectedDate(newValue);
                    }}
                    displayStaticWrapperAs="desktop"
                    components={{
                        SwitchViewButton: (buttonProps) => (
                            <IconButton {...buttonProps}>
                                <ArrowUpNew /> {/* Custom icon */}
                            </IconButton>
                        ),
                    }}
                    componentsProps={{
                        actionBar: { sx: { display: "none" } }, // Hides the action toolbar
                    }}
                    className={classes.calendarClass}
                    inputFormat="DD MMM YYYY"
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{
                                width: "200px", // Set width to 200px
                                "&.MuiTextField-root": {
                                    marginBottom: "0px !important",
                                },

                                "& .MuiOutlinedInput-root": {
                                    alignItems: "center",
                                    color: "#19442E",
                                    gap: "8px",
                                    borderRadius: "16px !important",
                                    border: "1px solid #F3F3F3",
                                    background: "#FFF",
                                    "& .MuiOutlinedInput-input": {
                                        padding: "16px 12px !important",
                                        color: "#19442E!important",
                                        '&::placeholder': {
                                            textTransform: "uppercase"
                                        },
                                    },
                                },
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {null}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    )}
                />
            )}

        </LocalizationProvider>
    </Box>
}